/* eslint-disable */
import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import App_data from '../../views/config/App_data';
import { messages } from '../../common/messages';
import {
  examNameAccordingToDB,
  examObject,
  getActiveExams,
  ROLES,
  SECTION_NAMES,
} from '../../common/constant';

import DashboardIcon from '../../../public/img/sidebar/dashboard-icon.svg';
import NotesIcon from '../../../public/img/sidebar/notes-icon.svg';
import VideoIcon from '../../../public/img/sidebar/video-icon.svg';
import QuestionBankIcon from '../../../public/img/sidebar/question-bank-icon.svg';
import QuizIcon from '../../../public/img/sidebar/quiz-icon.svg';
import EssayIcon from '../../../public/img/sidebar/essay-question-icon.svg';
import CBTIcon from '../../../public/img/sidebar/cbt-icon.svg';
import TutorIcon from '../../../public/img/sidebar/tutor-icon.svg';
import PremiumIcon from '../../../public/img/sidebar/premium.svg';
import Webinars from '../../../public/img/sidebar/webinars.svg';
import SubscriptionIcon from '../../../public/img/sidebar/subscription.svg';
import UserAvatar from "../Partial/UserAvatar";
import { isAiTutorAvailable } from '../../common/aiTutorContext';
const mobx = require('mobx');
const autorun = mobx.autorun;
import UserStore from '../../store/userStore';
import AppVersion from "./AppVersion";
import WebinarRESTService from "../../services/WebinarRESTService";
import userStore from "../../store/userStore";

/* eslint-disable*/

class Sidebar extends Component {
  state = {
    userToken: '',
    userIdName: '',
    userAvatar: '',
    isEmployee: false,
    isPremiumUser: true,
    isVideoEnabled: true,
    hasWebinars: false,
  };

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;
    if (pathname !== prevProps.location.pathname) {
      localStorage.setItem('sidebarRoute', pathname);
    }
  }

  componentDidMount = async () => {
    const localStorageData = JSON.parse(localStorage.getItem('localstorageval'));
    if (!localStorageData) return browserHistory.push('/');

    const { token, idname } = localStorageData;
    this.setState({ userToken: token, userIdName: idname });

    const payload = { token, idname };


    this.dispose = autorun(async () => {
      const profileInfo = UserStore.profileInfo;
      const webinarsAvailable = UserStore.isUserWebinarsAvailable;
      if (profileInfo) {
        const {role, isVideo, username, imageUrl, id, exam_selected, exam_package} = profileInfo;
        this.setState({
          isVideoEnabled: isVideo,
          isEmployee: role === ROLES.EMPLOYEE,
          userAvatar: String(imageUrl || `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`),
          greeting: `Welcome, ${username || 'Admin'}!`,
          userName: username,
          userId: id,
          isPremiumUser: exam_selected && exam_package,
          hasWebinars: webinarsAvailable,
        });
        await userStore.getUserWebinarsCount("Sidebar");
        console.log("Webinar Count", this.state.hasWebinars);
      }
    });




    // try {
    //   const response = await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, payload);
    //   const profile = response && response.profileInfo;
    //
    //   if (response.success && profile) {
    //     const { role, isVideo, username, imageUrl, id, exam_selected, exam_package } = profile;
    //
    //     this.setState({
    //       isVideoEnabled: isVideo,
    //       isEmployee: role === ROLES.EMPLOYEE,
    //       userAvatar: imageUrl || `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
    //       greeting: `Welcome, ${username || 'Admin'}!`,
    //       userName: username,
    //       userId: id,
    //       isPremiumUser: exam_selected && exam_package,
    //     });
    //
    //     localStorage.setItem('role', role);
    //   }
    // } catch (error) {
    //   this.setState({
    //     userAvatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
    //   });
    // }
  };

  getWebinarsCountByExam = async (token) => {
    try {
      const data = await new WebinarRESTService().setAuthHeader(token).getWebinarsCountByExam();
      if(data && data.count > 0) this.setState({ hasWebinars: true });
    } catch (e) {
      console.log("Error in getWebinarsCountByExam", e);
    }
  }


  isRouteMatch = (keywords) => {
    const { pathname } = this.props.location;
    const priorityRoutes = ['essay-question', 'notes', 'cbt', 'pathway'];

    for (const route of priorityRoutes) {
      if (pathname.includes(route)) return keywords.includes(route);
    }

    const lowerCasePath = pathname.toLowerCase();
    return keywords.some((keyword) => lowerCasePath.split(/\b/).includes(keyword.toLowerCase()));
  };

  renderSidebarItems = () => {
    const examName = localStorage.getItem('selectedmenu') || examNameAccordingToDB.CFA_LEVEL_1_2025;
    // cfa_2027 / cfa_2_2027 each have their own examObject entry whose sidebarRoutes point at the
    // /cfa1/2027/... resp. /cfa2/2027/... tree. getActiveExams() collapses them → the family's active
    // exam (cfa_2025 / cfa_2_2025), which would read the shared 2026 routes — so keep both preview
    // editions uncollapsed here. All other exams behave exactly as before.
    const selectedExam =
      examName === examNameAccordingToDB.CFA_LEVEL_1_2027 ||
      examName === examNameAccordingToDB.CFA_LEVEL_2_2027
        ? examName
        : getActiveExams(examName);
    const { isPremiumUser } = this.state;
    const routes = examObject[selectedExam] ? examObject[selectedExam].sidebarRoutes : {};

    const isExcludedFor = (...exams) => !exams.includes(selectedExam);
    const isIncludedFor = (...exams) => exams.includes(selectedExam);
    const { GMAT_FOCUS, EA, ESG, CFA_LEVEL_3, CFA_LEVEL_3_2025, SOA_P, SOA_FM, FRM } =
      examNameAccordingToDB;
    const sidebarItems = [
      {
        keyword: SECTION_NAMES.DASHBOARD,
        route: routes.dashboard,
        icon: DashboardIcon,
        label: messages.DASHBOARD,
        width: '28',
      },
      {
        keyword: SECTION_NAMES.WEBINARS,
        route: '/webinars',
        icon: Webinars,
        label: messages.WEBINARS,
        width: '31',
      },
      {
        keyword: SECTION_NAMES.NOTES,
        route: routes.notes,
        icon: NotesIcon,
        label: messages.STUDY_NOTES,
        condition: isExcludedFor(GMAT_FOCUS, EA),
        width: '26',
      },
      {
        keyword: SECTION_NAMES.VIDEOS,
        route: routes.videos,
        icon: VideoIcon,
        label: messages.VIDEO_LESSONS,
        width: '33',
      },
      {
        keyword: SECTION_NAMES.QUESTION_BANK,
        route: routes.questions,
        icon: QuestionBankIcon,
        label: messages.QUESTION_BANK,
        width: '34',
      },
      {
        keyword: SECTION_NAMES.QUIZZES,
        route: routes.quiz,
        icon: QuizIcon,
        label: messages.QUIZZES,
        condition: isExcludedFor(ESG),
        width: '29',
      },
      {
        keyword: SECTION_NAMES.ESSAY_QUESTION,
        route: routes.essay,
        icon: EssayIcon,
        label: messages.ESSAY_QUESTION,
        condition: isIncludedFor(CFA_LEVEL_3, CFA_LEVEL_3_2025),
        width: '29',
      },
      {
        keyword: SECTION_NAMES.CBT,
        route: routes.cbt,
        icon: CBTIcon,
        label: messages.CBT_MOCK_EXAM,
        condition: isExcludedFor(SOA_P, SOA_FM, GMAT_FOCUS, EA, CFA_LEVEL_3_2025),
        width: '39',
      },
      {
        keyword: SECTION_NAMES.PATHWAY,
        route: routes.pathway,
        icon: CBTIcon,
        label: messages.CBT_EXAM,
        condition: isIncludedFor(CFA_LEVEL_3, CFA_LEVEL_3_2025),
        width: '39',
      },
      {
        keyword: SECTION_NAMES.TUTOR,
        route: routes.tutor,
        icon: TutorIcon,
        label: messages.TUTORING,
        condition: isExcludedFor(ESG, FRM, SOA_P, SOA_FM),
        width: '31',
      },
      {
        keyword: SECTION_NAMES.SUBSCRIBE,
        route: routes.subscription,
        icon: isPremiumUser ? PremiumIcon : SubscriptionIcon,
        label: messages.UPGRADE_ACCOUNT,
        width: '31',
      },
    ];

    return sidebarItems
      .filter(({ condition }) => condition !== false)
      .map(({ keyword, route, icon, label, width, isNewBadge }, idx) => (
        <li
          key={idx}
          className={`nav-item pointer_class ${this.isRouteMatch(keyword) ? 'sidebar-active' : ''}`}
        >
          <Link to={route} activeClassName='active'>
            <img src={icon} alt={`${label} Icon`} width={width} />
            {isNewBadge && (<span className='badge badge-danger'>New</span>)}
            <div className='submenu_hover submenu_in'>
              <span className='sidebar-link'>{label}</span>
            </div>
          </Link>
        </li>
      ));
  };

  render() {
    const { userAvatar } = this.state;

    return (
      <div className='sidebar'>
        <nav className='sidebar-nav' id='side_bar_nav'>
          <div className='row no-gutters justify-content-center col-sm-12 profile_outer'>
            <div className='profile_wrapper'>
              <div className='online_status' />
              <UserAvatar />
              {/*<div className='sidebar-profile-circle'>*/}
              {/*  <div className='profile-img' style={{ backgroundImage: `url(${userAvatar})` }} />*/}
              {/*</div>*/}
            </div>
          </div>
          <ul className='nav' id='nav_id'>
            {this.renderSidebarItems()}
          </ul>
        </nav>
        {/* AI Tutor launcher — V1 is CFA Level 1 only (KB + entitlement are CFA-scoped),
            so hide it for other exams instead of offering a tutor that can't answer. */}
        {isAiTutorAvailable() && (
          <div className='ap-ai-launcher' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px auto auto' }}>
            {/* violet AI-Tutor identity (design 2026-07-08); soft glow pulse */}
            <style dangerouslySetInnerHTML={{ __html: '@keyframes apGlow{0%,100%{box-shadow:0 0 0 0 rgba(109,75,255,.28);}50%{box-shadow:0 0 0 5px rgba(109,75,255,.06);}}' }} />
            <button
              type='button'
              title='AI Tutor'
              aria-label='Open AI Tutor'
              onClick={() => window.dispatchEvent(new CustomEvent('aitutor:toggle'))}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: 13,
                border: 'none',
                cursor: 'pointer',
                color: '#fff',
                fontSize: 20,
                background: 'linear-gradient(135deg,#6d4bff 0%,#4a2fe0 100%)',
                boxShadow: '0 5px 16px rgba(74,47,224,.5)',
                animation: 'apGlow 2.6s ease-in-out infinite',
              }}
            >
              ✦
            </button>
            <span style={{ font: "800 8px 'Plus Jakarta Sans', system-ui, sans-serif", color: '#8a93c0', letterSpacing: '.06em', marginTop: 8, fontWeight: 900 }}>AI TUTOR</span>
          </div>
        )}
        <AppVersion />
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js